import React from "react";
import { ExternalOrderInfo } from "@api/throughShipment/throughShipmentApi";
import { Table } from "antd";
import mathUtils from "@utils/mathUtils";
import { Title, Row, RowContent } from "./style";

type OrderInfoProps = {
  externalOrderInfo?: ExternalOrderInfo;
  title: string;
  type: "final" | "expected";
};

const OrderInfoTable = (props: OrderInfoProps) => {
  const { externalOrderInfo, title, type } = props;
  const isFinal = type === "final";
  const columns = [
    {
      key: "totalRevenue",
      dataIndex: "totalRevenue",
      title: `${!isFinal ? "預估" : ""}訂單總營收`,
    },
    {
      key: "totalCost",
      dataIndex: "totalCost",
      title: `${!isFinal ? "預估" : ""}訂單總成本`,
    },
    {
      key: "totalOrderFee",
      dataIndex: "totalOrderFee",
      title: `${!isFinal ? "預估" : ""}訂單費用加總`,
    },
    {
      key: "totalMargin",
      dataIndex: "totalMargin",
      title: `${!isFinal ? "預估" : ""}毛利額`,
    },
    {
      key: "totalMarginRatio",
      dataIndex: "totalMarginRatio",
      title: `${!isFinal ? "預估" : ""}毛利率`,
    },
  ];

  const dataSource = externalOrderInfo
    ? [
        {
          totalRevenue: isFinal ? externalOrderInfo.totalRevenue : externalOrderInfo.expectedRevenue,
          totalCost: isFinal ? externalOrderInfo.totalCost : externalOrderInfo.expectedCost,
          totalOrderFee: isFinal ? externalOrderInfo.totalOrderFee : externalOrderInfo.expectedOrderFee,
          totalMargin: isFinal ? externalOrderInfo.totalMargin : externalOrderInfo.expectedMargin,
          totalMarginRatio: mathUtils.toPercentage(
            isFinal ? externalOrderInfo.totalMarginRatio : externalOrderInfo.expectedMarginRatio,
            2,
          ),
        },
      ]
    : [];

  return (
    <>
      <Title>{title}</Title>
      <Row marginTop="30px" marginBottom="20px">
        <RowContent width={10000}>
          <Table columns={columns} dataSource={dataSource} pagination={false} />
        </RowContent>
      </Row>
    </>
  );
};

export default OrderInfoTable;
